// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--2zXLw","header":"Layout-module--header--15Zjd","overlay":"Layout-module--overlay--1sPIK"};